/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  FilledTextFieldProps,
  OutlinedTextFieldProps,
  StandardTextFieldProps,
  TextField,
} from "@material-ui/core";
import { Option } from "../FlowioSelect/types";
import { selectWithSearchCss, selectWithSearchFWCss } from "./styles";
import VirtualListbox from "./VirtualListbox";

type ControlledOnlyProps = { value: string; defaultValue?: undefined };
type UncontrolledOnlyProps = { value?: undefined; defaultValue: string };

export type Props = (ControlledOnlyProps | UncontrolledOnlyProps) & {
  disabled?: boolean;
  id?: string;
  options: Option[];
  onChange: (v: string) => void;
  onBlur?(): void;
  placeholder?: string;
  name?: string;
  className?: string;
  fullWidth?: boolean;
  disableClearable?: boolean;
  emptyOption?: boolean;
  required?: boolean;
};

const FlowioSearchSelect: FC<Props> = ({
  // default, abych mel v useEffect mezistavech dynamickych formularu
  // (po zmene jineho inputu, nez se triggerne autokorekcni useEffect)
  // svobodu posilat undefined options
  options = [],
  value = "",
  name,
  required = false,
  onChange,
  onBlur,
  placeholder = "",
  disabled = false,
  className = "",
  id,
  fullWidth = false,
  disableClearable = false,
}) => (
  <Autocomplete
    id={id}
    options={options}
    // Null fallback, abych zabranil namountovani v uncontrolled modu, pokud bych tam poslal
    // undefined - pak nefunguje prekreslovani zmenou value/option, ale jen pres onChange
    value={options?.find((o) => String(o.value) === String(value)) ?? null}
    getOptionLabel={(o): string => String(o.name)}
    // otaznik, abych mel v useEffect mezistavech dynamickych formularu
    // (po zmene jineho inputu, nez se triggerne autokorekcni useEffect)
    // svobodu posilat undefined options
    getOptionSelected={(o, v) => String(o.value) === String(v?.value)}
    onChange={(e, newValue) => onChange(newValue?.value ?? "")}
    onBlur={onBlur}
    fullWidth={fullWidth}
    disabled={disabled}
    ListboxComponent={
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      options.length > 1000 ? (VirtualListbox as any) : undefined
    }
    disableClearable={disableClearable}
    renderInput={(params: RenderInputParams) => (
      <TextField
        {...params}
        // Null fallback, abych zabranil namountovani v uncontrolled modu, pokud bych tam poslal
        // undefined - pak nefunguje prekreslovani zmenou value/option, ale jen pres onChange
        value={params.value ?? null}
        variant="outlined"
        name={name}
        required={required}
        fullWidth={fullWidth}
        css={fullWidth ? selectWithSearchFWCss : selectWithSearchCss}
        className={className}
        placeholder={placeholder}
        disabled={disabled}
        data-cy="flowio-search-select"
      />
    )}
  />
);

type RenderInputParams =
  | (JSX.IntrinsicAttributes & StandardTextFieldProps)
  | (JSX.IntrinsicAttributes & FilledTextFieldProps)
  | (JSX.IntrinsicAttributes & OutlinedTextFieldProps);

export default FlowioSearchSelect;
export type FlowioSearchSelectProps = Props;
